module.exports = __webpack_public_path__ + "static/media/osviel.d86950c3.jpg";